export const Ens = () => {
  return (
    <svg width="202" height="230" viewBox="0 0 202 230">
      <path
        d="M166.879 123.34C167.377 122.52 168.535 122.429 169.153 123.162C174.745 129.803 195.579 158.052 169.798 183.8C146.274 207.294 116.31 224.046 105.205 229.835C103.945 230.492 102.618 229.077 103.354 227.863L166.879 123.34Z"
        fill="currentColor"
      />
      <path
        d="M5.90197 79.8242C6.42691 78.405 8.51451 78.7115 8.61975 80.2206C9.67438 95.3372 22.3135 113.006 28.7399 123.638C35.2552 134.417 82.421 206.221 96.61 227.803C97.4597 229.095 95.8973 230.609 94.6295 229.721L41.5592 192.574C8.11089 169.162 -7.29061 127.359 3.31408 87.9648C4.15404 84.8444 5.05544 82.1128 5.90197 79.8242Z"
        fill="currentColor"
      />
      <path
        d="M104.958 2.18353C104.108 0.891352 105.669 -0.621348 106.937 0.265561L160.008 37.413C193.456 60.8255 208.858 102.628 198.254 142.022C197.414 145.143 196.512 147.874 195.666 150.163C195.141 151.582 193.054 151.276 192.949 149.767C191.894 134.65 179.255 116.98 172.828 106.349C166.312 95.5694 119.147 23.7645 104.958 2.18353Z"
        fill="currentColor"
      />
      <path
        d="M96.2936 0.166928C97.5534 -0.489609 98.8805 0.925392 98.1432 2.13861L34.6188 106.662C34.1205 107.482 32.9633 107.573 32.3453 106.84C26.7528 100.199 5.91833 71.9497 31.6988 46.2021C55.2237 22.7074 85.1885 5.95651 96.2936 0.166928Z"
        fill="currentColor"
      />
    </svg>
  )
}
